const mastersRouteList = {
clinicMaster:"clinic-master",
generalMaster:"general-master",
templateMaster:"template-masters",
insuranceMaster:"insurance-masters",
googleForms: "google-forms",
googleFormsCreate: "create-form",
}

export default mastersRouteList;